import { View } from 'backbone.marionette';
import Syphon from 'backbone.syphon';
import Ladda from 'ladda';

import { validateForm } from '@/util/ParsleyUtils';
import showErrorMessage from '@/util/showErrorMessage';
import showSuccessMessage from '@/util/ShowSuccessMessage';

import RejectUserCommandMembership from '../../services/RejectUserCommandMembership';

import tmplMembershipRejectionReasonModalView from './MembershipRejectionReasonModalView.hbs';
const MembershipRejectionReasonModalView = View.extend({
  template: tmplMembershipRejectionReasonModalView,

  ui: {
    btnCancel: '.btn-cancel',
    btnReject: '.btn-reject',
    rejectionReasonForm: '.rejection-reason-form'
  },

  events: {
    'click @ui.btnCancel': 'cancelRejection',
    'click @ui.btnReject': 'rejectMembership'
  },

  showRejectionSuccessMessage() {
    showSuccessMessage({
      code: 'rejectionSuccess',
      title: 'Rejection Success',
      message: 'User has been rejected',
      hideAfter: 5
    });
  },

  showRejectionErrorMessage() {
    showErrorMessage({
      errorCode: 'rejectionError',
      errorTitle: 'Rejection Error',
      errorMessage: 'An error occurred while rejecting the user\'s request.'
    });
  },

  toggleForm(state = true) {
    this.ui.btnCancel.prop('disabled', !state);
    this.ui.btnReject.prop('disabled', !state);
  },

  async rejectMembership(e) {
    e.preventDefault();
    await validateForm(this.ui.rejectionReasonForm);
    const rejectReason = Syphon.serialize(this);
    const notificationId = this.model.get('id');
    const spinner = Ladda.create(this.ui.btnReject[0]);
    this.toggleForm(false);

    try {
      spinner.start();
      await RejectUserCommandMembership(notificationId, rejectReason);
      this.showRejectionSuccessMessage();
      this.closeModal(this.model);
    } catch (err) {
      if (err.message.string === 'COMMAND_REMOVED') {
        this.showExternalUserCancelledRequestMessage();
      } else {
        this.showRejectionErrorMessage();
      }
    } finally {
      this.toggleForm();
      spinner.stop();
    }
  },

  closeModal(model) {
    this.triggerMethod('modal:close', model);
  }
});

export default MembershipRejectionReasonModalView;
